import { cn } from "@/lib/utils";

interface GridBackgroundProps {
  variant?: "dots" | "grid" | "gradient";
  className?: string;
}

export const GridBackground = ({ variant = "dots", className }: GridBackgroundProps) => {
  return (
    <div
      className={cn(
        "absolute inset-0 pointer-events-none",
        variant === "dots" && "bg-dot-pattern opacity-30",
        variant === "grid" && "bg-grid-pattern opacity-20",
        variant === "gradient" && "bg-gradient-mesh",
        className
      )}
      aria-hidden="true"
    />
  );
};

export default GridBackground;
